import React, { useEffect, useRef, useState } from "react";
import { Check } from "lucide-react";
import { businessInfo, heroImages } from "../data/mockData";

const About = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.15 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  const features = [
    "F-Gas & NVQ3 qualified engineer",
    "A member of REFCOM",
    "5.0★ rated on Google",
    "Free, no-obligation quotes",
  ];

  return (
    <section id="about" ref={sectionRef} className="py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-20 items-center">
          {/* Left Content */}
          <div
            className={`transition-all duration-350 ${
              isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"
            }`}
          >
            <p className="text-brand-mint-dark text-xs font-bold uppercase tracking-[0.25em] mb-4">
              About Us
            </p>
            <h2 className="font-heading text-3xl lg:text-4xl text-gray-900 mb-8 leading-snug">
              Air Conditioning You Can Trust
            </h2>
            <p className="text-gray-500 text-[15px] leading-[1.8] mb-6">
              Kold Air Ltd is a family run air conditioning specialist based in
              Cottingham, serving Yorkshire and the surrounding areas. We
              design, install, maintain and repair AC systems with a focus on
              quality work, energy efficiency and clean installations.
            </p>
            <p className="text-gray-500 text-[15px] leading-[1.8] mb-10">
              From single-room residential splits to large commercial fit-outs,
              heating and cooling systems — no project is too big or
              too small. F-Gas and REFCOM certified, with a 5.0★ Google rating
              backing up every job we do.
            </p>

            <div className="grid sm:grid-cols-2 gap-4">
              {features.map((feature, i) => (
                <div key={i} className="flex items-center gap-3">
                  <div className="w-5 h-5 rounded-full bg-brand-mint/20 flex items-center justify-center flex-shrink-0">
                    <Check className="w-3 h-3 text-brand-mint-dark" />
                  </div>
                  <span className="text-gray-600 text-sm font-medium">
                    {feature}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* Right Image */}
          <div
            className={`relative transition-all duration-350 delay-75 ${
              isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"
            }`}
          >
            <div className="relative">
              <img loading="lazy" decoding="async"
                src={heroImages.about}
                alt="Professional Craftsmanship"
                className="rounded-2xl w-full h-[480px] object-cover"
                style={{ boxShadow: '0 25px 50px -12px rgba(0,0,0,0.15)' }}
              />
              {/* Rating Badge (replaces years-experience badge) */}
              <div className="absolute -bottom-5 -left-5 bg-white rounded-xl shadow-lg p-5 border border-gray-50 flex items-center gap-3">
                <div>
                  <div className="text-3xl font-heading text-brand-charcoal leading-none">
                    {businessInfo.rating.toFixed(1)}
                    <span className="text-brand-gold-dark">★</span>
                  </div>
                  <div className="text-[10px] text-gray-400 font-semibold uppercase tracking-wider mt-1">
                    {businessInfo.reviewCount} Google Reviews
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
